import { render, staticRenderFns } from "./CustomMealDeal.vue?vue&type=template&id=47c3cf8e&scoped=true&"
import script from "./CustomMealDeal.vue?vue&type=script&lang=js&"
export * from "./CustomMealDeal.vue?vue&type=script&lang=js&"
import style0 from "./CustomMealDeal.vue?vue&type=style&index=0&id=47c3cf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3cf8e",
  null
  
)

export default component.exports